import { render, staticRenderFns } from "./CounselingRecord.vue?vue&type=template&id=7a56bcdd&scoped=true"
import script from "./CounselingRecord.vue?vue&type=script&lang=js"
export * from "./CounselingRecord.vue?vue&type=script&lang=js"
import style0 from "./CounselingRecord.vue?vue&type=style&index=0&id=7a56bcdd&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a56bcdd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a56bcdd')) {
      api.createRecord('7a56bcdd', component.options)
    } else {
      api.reload('7a56bcdd', component.options)
    }
    module.hot.accept("./CounselingRecord.vue?vue&type=template&id=7a56bcdd&scoped=true", function () {
      api.rerender('7a56bcdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/components/campusPreview/CounselingRecord.vue"
export default component.exports